module.exports = __webpack_public_path__ + "media/use-form/workshops-courses@2x-3ce96e25.png";